<template>
  <Form style="line-height:32px"
        :model="formdata"
        :label-width="120"
        inline
        ref="form">
    <FormItem label='备注'
              style="width:90%"
              :rules='required'
              prop="remark">
      <Input v-model="formdata.remark"
             :rows="3"
             type="textarea" />
    </FormItem>
    <footer class="text-right">
      <Button type="primary"
              @click="submit">保存</Button>
      <Button class="margin-left-10"
              @click="cancel">取消</Button>
    </footer>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </Form>
</template>
<script>
import {
  HttpAddRemark
} from '@/service/boss/b2corder'
export default {
  props: ['activeids'],
  data () {
    return {
      loading: false,
      formdata: {
        remark: "",
      },
      required: [{
        required: true,
        message: "该信息不能为空,请填写"
      }],
    }
  },
  methods: {
    cancel () {
      this.$emit('on-close')
    },
    async submit () {
      let data = await this.$refs['form'].validate();
      if (!data) return;
      this.loading = true;
      HttpAddRemark({
        orderIds: this.activeids,
        remark: this.formdata.remark
      }).then(res => {
        this.$Message.success(res.message);
        this.cancel();
        // if(this.$route.name=='b2cOrderupdate'){
        //     this.$router.push({
        //         name:'b2cOrder'
        //     })
        // }else{
        this.$emit('on-update');
        // }
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>
